/* WeQuote Dev Board — notification settings (Lee, 26 Aug). Configures which
 * card events email the assigned developer (server-enforced), plus the
 * Needs-Review intake alert recipients. Stored server-side for everyone. */
import React, { useEffect, useState } from 'react'
import { fetchSettings, saveSettings, type BoardSettings } from '../core/api'
import { useDevBoard } from '../DevBoardProvider'

export const NotifySettingsModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { showToast } = useDevBoard()
  const [sx, setSx] = useState<BoardSettings | null>(null)
  const [saving, setSaving] = useState(false)
  useEffect(() => {
    fetchSettings().then(setSx).catch(() => { showToast('Could not load notification settings.'); onClose() })
  }, [])
  if (!sx) return null
  const setTrig = (k: keyof BoardSettings['triggers'], v: boolean) => setSx({ ...sx, triggers: { ...sx.triggers, [k]: v } })
  const save = async () => {
    setSaving(true)
    try {
      await saveSettings(sx)
      showToast('Notification settings saved.')
      onClose()
    } catch {
      showToast('Save failed — try again.')
      setSaving(false)
    }
  }
  return (
    <div className="overlay open" style={{ zIndex: 130 }} onClick={(e) => { if ((e.target as HTMLElement).classList.contains('overlay')) onClose() }}>
      <div className="modal" style={{ width: 480 }}>
        <h2>Email notifications</h2>
        <div className="modal-sub">Server-side triggers — they fire no matter who makes the change, and every sent email is recorded on the card.</div>
        <div className="fg"><label>Stage emails</label>
          <label className="rq-design"><input type="checkbox" checked={sx.triggers.review} onChange={(e) => setTrig('review', e.target.checked)} /> Lands in <b>Needs Review</b> → the sign-off list below</label>
          <label className="rq-design"><input type="checkbox" checked={sx.triggers.priority} onChange={(e) => setTrig('priority', e.target.checked)} /> Added to the <b>Priority List</b> → everyone</label>
          <label className="rq-design"><input type="checkbox" checked={sx.triggers.devcolumn} onChange={(e) => setTrig('devcolumn', e.target.checked)} /> Lands on a <b>dev’s Kanban column</b> → Natalie (“development has begun”)</label>
          <label className="rq-design"><input type="checkbox" checked={sx.triggers.assigned} onChange={(e) => setTrig('assigned', e.target.checked)} /> <b>Assigned</b> to a dev/user → that person (“assigned to you”)</label>
          <label className="rq-design"><input type="checkbox" checked={sx.triggers.live} onChange={(e) => setTrig('live', e.target.checked)} /> Goes <b>Live</b> → everyone (non-devs included)</label>
        </div>
        <div className="fg">
          <label>Needs-Review sign-off list</label>
          <input value={sx.intakeRecipients} onChange={(e) => setSx({ ...sx, intakeRecipients: e.target.value })} placeholder="comma-separated emails" />
          <span className="eg-hint">Comma-separated. “Everyone” means every active support-app account.</span>
        </div>
        <div className="factions">
          <button className="btn-s" onClick={onClose}>Cancel</button>
          <button className="btn-p" disabled={saving} onClick={() => { void save() }}>{saving ? 'Saving…' : 'Save'}</button>
        </div>
      </div>
    </div>
  )
}
